import React, { FC } from 'react';
import { useRouter } from '@funtech-int/rival-react';

import { Button } from '@/shared/components/Button/Button';
import { TextWeight, TextTag, TextSize, Theme } from '@/shared/components/Text';
import { Text } from '@/shared/components/Text/Text';
import { useClientSupport } from '@/shared/hooks/useClientSupport';
import { mainRoute } from '@/scenarios/home';

import { useI18n } from '../../hooks/useI18n';

import styles from './ClientError.module.css';

interface ClientErrorProps {
    status: number;
    title: string;
    description: string;
}

export const ClientError: FC<ClientErrorProps> = ({ description, status, title }) => {
    const { openClientSupport } = useClientSupport();
    const router = useRouter();
    const i18n = useI18n();

    return (
        <div className={styles.root}>
            <div className={styles.headline}>
                <Text weight={TextWeight.Bold} theme={Theme.Dark} size={TextSize.TitlePage}>
                    {status}
                </Text>
                <Text
                    weight={TextWeight.Bold}
                    tag={TextTag.H1}
                    theme={Theme.Dark}
                    size={TextSize.TitlePage}
                >
                    {title}
                </Text>
            </div>
            <Text
                className={styles.description}
                weight={TextWeight.Regular}
                size={TextSize.Subtitle}
            >
                {description}
            </Text>
            <div className={styles.buttons}>
                <Button
                    as="a"
                    href={router.serialize(mainRoute())}
                    size={52}
                    variant="primary"
                    theme="dark"
                >
                    {i18n('back_to_home__title')}
                </Button>
                <Button
                    variant="secondaryTransparent"
                    theme="dark"
                    size={52}
                    onClick={openClientSupport}
                    className={styles.button}
                >
                    {i18n('contact_support__title')}
                </Button>
            </div>
        </div>
    );
};
